import React, { useState, useRef, useEffect } from 'react'

import { Carousel as CarouselComp } from 'react-responsive-carousel'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { BreadCrumbs } from '../..'
import { useEventListener } from '../../../_helpers'
import {
    devices,
    colors,
    CarouselNext,
    CarouselPrev,
    // Title,
    ThumbnailsIcon,
    minDevices,
} from '../../Common'

const Slide = ({ image }) => {
    const { image: img, alt_text } = image
    const [height, setHeight] = useState(0)
    let i = new Image()
    i.src = img
    const orientation = i.width > i.height ? 'landscape' : 'portrait'
    const card = useRef()

    const updateHeight = () => {
        const ratio = orientation === 'landscape' ? i.height / i.width : i.height / i.width
        const width = card.current.offsetWidth
        setHeight(Math.round(ratio * width))
    }

    useEffect(() => {
        updateHeight()
    }, [])

    useEventListener('resize', updateHeight)

    return <ImageCard ref={card} height={height} background={img} alt={alt_text} orientation={orientation} />
}


export const SimpleCarousel = ({ slides, close, activeImage, mobile, title }) => {
    const [activeSlide, setActiveSlide] = useState(activeImage)
    const [caption, setCaption] = useState(slides[activeImage].author)

    const handleChange = id => {
        setActiveSlide(id)
        setCaption(slides[id].author)
    }

    const next = () => setActiveSlide(activeSlide + 1)
    const prev = () => setActiveSlide(activeSlide - 1)

    return (
        <CarouselContainer>
            <CarouselFlex>
                <CarouselPrev onClick={prev} role='button' aria-label='Previous slide' />
                <CarouselCard>
                    <BreadCrumbs title={title} mobile={mobile} />
                    <StyledCarousel
                        showStatus={false}
                        showArrows={false}
                        showThumbs={false}
                        showIndicators={false}
                        infiniteLoop={slides.length > 1}
                        stopOnHover={false}
                        interval={5000}
                        transitionTime={0}
                        autoPlay={false}
                        selectedItem={activeSlide}
                        onChange={handleChange}
                        dynamicHeight={true}
                    >
                        {slides.map(image => <Slide key={image.image} image={image} />)}
                    </StyledCarousel>
                    <ThumbnailButton onClick={close}>
                        <ThumbnailsIcon />
                        Show Thumbnails
                    </ThumbnailButton>
                    <Caption>{caption || ' '}</Caption>
                </CarouselCard>
                <CarouselNext onClick={next} role='button' aria-label='Next slide' />
            </CarouselFlex>
        </CarouselContainer>
    )
}

const ThumbnailButton = styled.div`
    margin-top: 10px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colors.white};
    font-family: pragmatica-extended, sans-serif;
    font-weight: 900;
    font-size: 12px;
    position: absolute;
    cursor: pointer;
    letter-spacing: 0.5px;
`

const CarouselCard = styled.div`
    @media ${devices.small} {
        width: 100%;
    }

    @media ${minDevices.small} {
        width: 84%;
    }

    @media ${minDevices.large} {
        width: 90%;
    }
`

const CarouselContainer = styled.div`
    /* position: relative; */
    padding-top: 50px;
    padding-bottom: 50px;

    @media ${devices.small} {
        align-self: flex-start;
        padding-left: 20px;
        padding-right: 20px;
    }

    @media ${minDevices.small} and ${devices.large} {
        padding-left: 48px;
        padding-right: 48px;
    }
`

const StyledCarousel = styled(CarouselComp)`

    @media ${devices.small} {
    }

    .slide {
        background: transparent;
        transition: opacity 600ms ease-in-out;
        opacity: 1;
        &:not(.selected) {
            opacity: 0;
        }
    }

    && {
        .control-dots {
            display: none;
        }
    }
`

export const VideoThumbnail = styled.div`
    height: ${({ height }) => height}px;
    background: url(${({ image }) => image});
    background-position: center;
    background-size: cover;
    cursor: pointer;

    @media ${devices.small} {
        height: 210px;
    }
`

export const VideoPlayButton = styled.div`
    height: 55px;
    width: 47px;
    background: url(/static/images/sprite.svg) -1px -570px;
    cursor: pointer;
`

const ImageCard = styled.div`
    width: ${props => props.orientation === 'landscape' ? '100%' : '43%'};
    /* height: 0; */
    height: ${props => props.height}px;
    /* padding-bottom: 56.25%; */
    background: url(${props => props.background}) no-repeat center/cover;
    margin-bottom: 0;
    background-position: top;
    border: 7px solid white;
    position: relative;
    margin: 0 auto;
    @media ${devices.small} {
        border-width: 3px;
    }
`

const CarouselFlex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
`

const Caption = styled.div`
    font-size: 10px;
    text-align: end;
    margin-top: 10px;
    color: ${colors.white};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-family: pragmatica-extended, sans-serif;
    font-weight: 400;
    font-style: normal;
`
